import { isDebugEnabled } from "./env";
import { metrics } from "./metrics";

export function debugLog(action: string, payload?: unknown): void {
  if (!isDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.groupCollapsed(`%c[analytics] ${action}`, "color:#06f;font-weight:600");
  if (payload !== undefined) {
    // eslint-disable-next-line no-console
    console.log("payload:", payload);
  }
  // eslint-disable-next-line no-console
  console.log("metrics:", metrics.snapshot());
  // eslint-disable-next-line no-console
  console.groupEnd();
}

export function debugWarn(msg: string, err?: unknown): void {
  if (!isDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.warn(`[analytics] ${msg}`, err ?? "");
}
